import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const baseUrl = config.baseUrl;
const participantesEndpoint = '/api/participantesSostenibilidad/';
const enfoqueEtnicoEndpoint = '/api/enfoqueEtnia/';

// ✅ Crear una instancia de Axios
const api = axios.create({
    baseURL: baseUrl,
});

// ✅ Interceptor para agregar el token a cada solicitud
api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

//Insertar un participante
export const insertParticipanteSostenibilidad = async (data) => {
    try {
        const response = await axios.post(`${baseUrl}${participantesEndpoint}`, data);
        return response.data;
    } catch (error) {

        // Manejo de errores de Axios
        let errorMessage = "Error al insertar participante.";
        
        if (error.response) {
            // Error con respuesta del servidor
            errorMessage = error.response.data?.message || `Error ${error.response.status}: Problema en el servidor`;
        } else if (error.request) {
            // La petición fue enviada pero no hubo respuesta
            errorMessage = "No se recibió respuesta del servidor. Verifique su conexión.";
        } else {
            // Error de configuración u otro problema
            errorMessage = error.message;
        }

        return { status: false, message: errorMessage }; // Devuelve un objeto estructurado en lugar de lanzar error
    }
};



// 🔍 Obtener todos los participantes de sostenibilidad
export const getAllparticipantesSostenibilidad = async () => {
    try {
        const response = await axios.get(`${baseUrl}${participantesEndpoint}`);
        return response.data;
    } catch (error) {
        console.error("Error al obtener todos los POAs:", error);
        throw error;
    }
};


// 🔍 Obtener todos los enfoques de etnia
export const getAllEnfoqueEtnia = async () => {
    try {
        const response = await axios.get(`${baseUrl}${enfoqueEtnicoEndpoint}`);
        return response.data;
    } catch (error) {
        console.error("Error al obtener todos los enfoques de etnia:", error);
        throw error;
    }
};
